import { Grid, Typography } from "@mui/material";
import styled from "styled-components/macro";

import { Loader, Paper } from "../../../components";
import { HeadingEighteen } from "../../css components/Style";
import { CircularProgress, Box } from "@mui/material";

const Subtitle = styled(Typography)`
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #000000;
  opacity: 0.4;
`;

const Link = styled(Typography)`
  font-weight: 600;
  font-size: 22px;
  line-height: 27px;
`;

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default function CampaignStatusBanner({
  campaignStatus,
  intersectionAudience,
  displayMessage,
  isCommonPidFound,
}) {
  if (!campaignStatus) {
    return (
      <Wrapper
        style={{
          width: "100%",
          justifyContent: "center",
          alignItems: "flex-start",
          padding: "24px 0",
        }}
      >
        <CircularProgress sx={{ color: "#02A0FC" }} />
      </Wrapper>
    );
  }
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Paper
          sx={{
            width: "100%",
            boxSizing: "border-box",
          }}
        >
          <Grid item xs={12}>
            <Link>Campaign Status</Link>
          </Grid>
          <Grid item xs={4}>
            <Subtitle>Status</Subtitle>
            <HeadingEighteen>
              {campaignStatus?.replace(/_/g, " ") || "N.A"}
            </HeadingEighteen>
          </Grid>
          {campaignStatus === "READY" && (
            <Grid item xs={4}>
              <Subtitle>Intersection Audience</Subtitle>
              <HeadingEighteen>{intersectionAudience ?? "N.A"}</HeadingEighteen>
            </Grid>
          )}
          {isCommonPidFound === false && (
            <Grid item xs={4}>
              <Subtitle>Message</Subtitle>
              <HeadingEighteen
                sx={{
                  fontSize: "16px",
                  fontWeight: 500,
                  lineHeight: 1.5,
                }}
              >
                {displayMessage || "N.A"}
              </HeadingEighteen>
            </Grid>
          )}
        </Paper>
      </Grid>
    </Grid>
  );
}
